import React from 'react'
import R from 'ramda'
import DoubleInputRange from './DoubleInputRange'

const AreaRange = ({unit, min, max, onChange, onUpdate}) => {
  const vv = validValues[unit] || validValues[defaultUnit]
  return <DoubleInputRange
            unit={unit}
            minValue={min}
            maxValue={max}
            validValues={vv}
            onChange={(values) => onChange(values)}
            onUpdate={(values) => onUpdate(values)}
            />
}

const validValues = {
  m2: [0,50,75,100,125,150,200,250,300,400,500,1000],
  ft2: [0,250,500,1000,1100,1200, 1300, 1400, 1500, 1750, 1900, 2000, 3000, 4000, 5000]
}

const defaultUnit = "ft2"
AreaRange.defaultProps = {
  unit: defaultUnit,
  min: R.head(validValues[defaultUnit]),
  max: R.last(validValues[defaultUnit]),
}

export default AreaRange



/** WEBPACK FOOTER **
 ** ./app/components/AreaRange.jsx
 **/